import axios from 'axios';

export default {
  // DEPRECATED use saveItemV2 instead
  saveItem(item){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/items", item)
      .then(results=>{
        return results.data;
      })
  },
  saveItemV2(inventoryId, productId, item){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+`/API/latest/admin/inventories/${inventoryId}/products/${productId}/items`, item)
      .then(results=>{
        return results.data;
      })
  },
  getItem(itemId){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/items/"+itemId)
      .then(results=>{
        return results.data;
      })
  },
  // DEPRECATED use updateItemV2 instead
  updateItem(itemId,item){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/items/"+itemId, item)
      .then(results=>{
        return results.data;
      })
  },
  updateItemV2(inventoryId, productId, itemId,item){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+`/API/latest/admin/inventories/${inventoryId}/products/${productId}/items/${itemId}`, item)
      .then(results=>{
        return results.data;
      })
  },
  updateItems(items){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/items", items)
      .then(results=>{
        return results.data;
      })
  },
  fetchInStockItems(){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/items?inStock=true")
      .then(results=>{
        return results.data;
      })
  },
  validateItem({item_header_id, itemId},inventoryId, qtyOrdered){
    let params = {inventoryId, qtyOrdered, itemId};
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/items/"+item_header_id+"/validate",{params})
      .then(results=>{
        return results.data;
      })
  },
  calculateItems(items){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/items/calculate",items)
      .then(results=>{
        return results.data;
      })
  },
  getPrice(itemId, customerId){
    let params = {customerId : customerId}
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/items/"+itemId+"/price",{params})
      .then(results=>{
        return results.data;
      })
  },
  // DEPRECATED use listItemsV2 instead
  listItems(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/items",{params})
      .then(results=>{
        return results.data;
      })
  },
  listItemsV2(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/products/items",{params})
      .then(results=>{
        return results.data;
      })
  },
  getItemsPrices(itemsIds, customerId){
    let params  = {};
    params.price = true;
    params.itemId = itemsIds;
    params.customerId = customerId;
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/items",{params})
      .then(results=>{
        return results.data;
      })
  }
}
